/* Runtime accessibility and interaction fixes for the 2026-09-15 feedback release. */
(function(){
  "use strict";
  var body=document.body;
  if(!body) return;
  var path=(document.querySelector("main")?.dataset.caqaSource || window.location.pathname).replace(/\.html$/i,"").replace(/\/$/,"")||"/";
  var page=path.split("/").filter(Boolean).pop()||"home";
  body.classList.add("qa-"+page.replace(/[^a-z0-9_-]/gi,"-"));
  if(path==="/testimonials") body.classList.add("qa-testimonials");
  if(path==="/useful-information") body.classList.add("qa-link-library");
  if(path==="/pricing") body.classList.add("qa-pricing");
  if(path==="/webinars") body.classList.add("qa-webinars");
  if(path==="/about") body.classList.add("qa-about");
  if(path==="/quality-guarantee") body.classList.add("qa-quality");
  if(path==="/case-studies") body.classList.add("qa-case-studies");
  if(path==="/awards") body.classList.add("qa-awards");
  if(path==="/book"||path==="/contact") body.classList.add("qa-form-page");
  if(/^\/(terms-and-conditions|disclaimer|licence-agreement|privacy-policy|cookies-policy|pre-order-products-policy|returns-and-refund-policy|resource-development-and-scorm-policy|superseded-training-products-policy|false-information-and-defamation-policy|policies)$/.test(path)) body.classList.add("qa-policy-page");
  if(/^\/services\//.test(path)) body.classList.add("qa-service-page");
  if(/^\/sectors\//.test(path)) body.classList.add("qa-sector-page");
  if(/^\/blogs\/e_zines\//.test(path)) body.classList.add("qa-magazine-page");
  document.documentElement.classList.remove("no-js");
  body.classList.remove("is-loading");
  document.querySelectorAll(".staging").forEach(function(el){el.remove();});

  // Keep the active menu state correct for nested service/sector pages.
  document.querySelectorAll(".nav__it").forEach(function(item){
    var active=false;
    item.querySelectorAll("a[href]").forEach(function(a){
      var href=a.getAttribute("href")||"";
      if(href.charAt(0)==="/" && href!=="/" && (path===href.replace(/\/$/,"") || path.indexOf(href.replace(/\/$/,"")+"/")===0)) active=true;
    });
    if(active) item.classList.add("qa-active");
  });

  // Make explicit the links that should open in a new tab and retain a visual arrow.
  var newTabPage=/^\/(about|book|contact|team|credits|useful-information|policies|terms-and-conditions|disclaimer|licence-agreement|privacy-policy|cookies-policy|pre-order-products-policy|returns-and-refund-policy|resource-development-and-scorm-policy|superseded-training-products-policy|false-information-and-defamation-policy)$/.test(path)||body.classList.contains("qa-magazine-page");
  document.querySelectorAll("a[href]").forEach(function(a){
    var href=a.getAttribute("href")||"";
    var external=/^https?:\/\//i.test(href) && !/^https?:\/\/new\.caqa\.com\.au/i.test(href);
    var inMain=!!a.closest("main");
    if(external){
      a.target="_blank";
      var rel=(a.getAttribute("rel")||"").split(/\s+/).filter(Boolean);
      if(rel.indexOf("noopener")<0) rel.push("noopener");
      a.rel=rel.join(" ");
    }
  });

  // First choice is usable immediately, while retaining native form semantics.
  document.querySelectorAll(".pick input[type=radio][name=tp]").forEach(function(input,i){if(i===0) input.checked=true;});
  ["#pt","#et"].forEach(function(sel){var select=document.querySelector(sel);if(select&&select.options.length) select.selectedIndex=0;});
  document.querySelectorAll("input[type=tel]").forEach(function(input){
    input.setAttribute("inputmode","tel");
    input.removeAttribute("pattern");
  });

  // Accordions are keyboard/native details controls with a visible plus state.
  var accordions=body.classList.contains("qa-service-page")?document.querySelectorAll("details.keep"):document.querySelectorAll(".acc details");
  if(accordions.length && !Array.from(accordions).some(function(d){return d.open;})) accordions[0].open=true;
  document.querySelectorAll("details.keep, .acc details").forEach(function(d){
    var s=d.querySelector("summary");
    if(!s) return;
    d.addEventListener("toggle",function(){s.setAttribute("aria-expanded",String(d.open));});
    s.setAttribute("aria-expanded",String(d.open));
  });

  var motion=document.createElement("button");
  motion.type="button"; motion.className="qa-motion-toggle"; motion.setAttribute("aria-label","Toggle motion");
  var motionOff=document.documentElement.getAttribute("data-motion")==="off";
  function paintMotion(){motion.textContent=motionOff?"Motion off":"Motion on";motion.setAttribute("aria-pressed",String(!motionOff));document.documentElement.setAttribute("data-motion",motionOff?"off":"on");}
  motion.addEventListener("click",function(){motionOff=!motionOff;try{localStorage.setItem("caqa-motion",motionOff?"off":"on");}catch(e){}paintMotion();});
  try{var saved=localStorage.getItem("caqa-motion");if(saved==="off") motionOff=true;if(saved==="on") motionOff=false;}catch(e){}
  paintMotion(); body.appendChild(motion);

  var top=document.createElement("button");
  top.type="button";top.className="qa-back-to-top";top.setAttribute("aria-label","Back to top");top.title="Back to top";top.textContent="↑";
  top.addEventListener("click",function(){window.scrollTo({top:0,behavior:motionOff?"auto":"smooth"});});body.appendChild(top);
  function onScroll(){top.classList.toggle("qa-visible",window.scrollY>240);}
  window.addEventListener("scroll",onScroll,{passive:true});onScroll();

  // Keep the footer's credit visible on every public page.
  var footer=document.querySelector("footer.ft");
  if(footer && !footer.querySelector(".qa-credit")){
    var credit=document.createElement("span");credit.className="qa-credit";credit.textContent="";
    var bot=footer.querySelector(".ft__bot");(bot||footer).appendChild(credit);
  }

  // Webinars: show the live CAQA Skills catalogue separately from recordings.
  if(body.classList.contains("qa-webinars")){
    var grid=document.querySelector("main .wrap.sec .grid.grid--3");
    if(grid && !document.querySelector("[data-qa-upcoming]")){
      var box=document.createElement("div");box.className="qa-upcoming";box.setAttribute("data-qa-upcoming","");
      box.innerHTML='<p>See the next available CAQA Skills session and reserve a place.</p><a class="btn btn--primary" target="_blank" rel="noopener" href="https://caqaskills.com.au/webinars/">View upcoming sessions</a>';
      grid.parentNode.insertBefore(box,grid);
    }
  }
})();
